import initApi from './init';
import client from './client';

initApi();

export default client;
